const branchesPath = '/branches';
export const getBranches = branchesPath;
export const getWDCBranches = (wdcBranchId: number) => `${branchesPath}?status=all&dataSource=wdc&wdcBranch=${wdcBranchId}`;
export const getBranchById = (id: number) => `${branchesPath}/${id}?`;
export const createBranch = `${branchesPath}`;
export const updateBranch = (id: number) => `${branchesPath}/${id}`;
export const updateBranchStatus = (id: number) => `${branchesPath}/${id}/activation`;
export const getBranchesRating = `/facilities/rating/branches`;
